import { Box } from '@mui/material';
import { ContainerProps } from './container.interface';

export function ContainerComponent({ children }: ContainerProps) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 1080,
        mx: 'auto',
        flex: '1 0 auto',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Box>
  );
}
